import {Injectable, Injector} from '@angular/core';
import {TableAbstractService} from './abstract-table.service';

@Injectable({
    providedIn: 'root'
})
export abstract class AbstractTableToolsService extends TableAbstractService {
    private _record: any;
    private _record_list: any[] = [];


    constructor(protected Injector2: Injector) {
        super(Injector2);
    }

    // ---------------------------------------------------------------------------
    get value(): any {
        return this._record;
    }
    set value(new_record: any) {
        this._record = new_record;
    }

    // ---------------------------------------------------------------------------
    get list_value(): any[] {
        return this._record_list;
    }
    set list_value(new_record_list: any[]) {
        this._record_list = new_record_list;
    }

    // ---------------------------------------------------------------------------
    get empty_record(): any {
        return this._getNewEmptyRecord();
    }

    // ---------------------------------------------------------------------------
    public resetRecord(): any {

        this.value = this._getNewEmptyRecord();

        return this.value;

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    // 
    // ===========================================================================
    // ---------------------------------------------------------------------------
    public setFieldValue(field_name: string, value: number | string): void {

        if (typeof this._record[field_name] !== 'undefined') {
            this._record[field_name] = value;
        }

    }

    // ---------------------------------------------------------------------------
    public getFieldValue(field_name: string): any {

        return this._record[field_name];

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    protected abstract _getNewEmptyRecord(): any;


}
